<div class="d-flex justify-content-between align-items-center my-2">
  <div class="d-flex align-items-center">
    <img alt="add_reason icon" src="../../../../assets/images/add_reason.png" />
    <div class="card-sub-heading ml-3 bold">Add Reason</div>
  </div>
  <button mat-icon-button (click)="this.dialogRef.close()" type="button">
    <img alt="close icon" src="assets/images/icons/grey_cross_icon.png" />
  </button>
</div>
<form [formGroup]="form" (ngSubmit)="!disableButton && formSubmit()">
  <div class="mb-2">
    <input
      type="text"
      formControlName="name"
      class="form-control"
      placeholder="Enter reason name"
    />
    <app-error-message
      [formName]="form"
      [fieldName]="'name'"
      [type]="'group'"
    >
    </app-error-message>
  </div>

  <div class="d-flex mt-4">
    <div class="col-md-12 d-flex justify-content-center">
      <button
        class="custom-btn w-100"
        type="button"
        (click)="this.dialogRef.close()"
      >
        Cancel
      </button>
      <button class="custom-btn w-100" [disabled]="!form.valid || disableButton" type="submit">
        Add to group <span class="whiteLoader" *ngIf="isLoading"></span>
      </button>
    </div>
  </div>
</form>
